/* ===================================================================
   PUHELINNUMERO ENNEN KASSAA  →  assets/phone-gate.js
   ===================================================================
   Sieppaa kassalle-siirtymisen (korisivun submit-napit + minicartin
   checkout-linkki) ja vaatii puhelinnumeron ENNEN jatkoa. Numero
   tallennetaan cart-attribuuttiin "Puhelin" (/cart/update.js) → näkyy
   tilauksen Lisätiedoissa hallinnassa.

   Yhteispeli pickup-schedulerin kanssa:
   - Pickup lukitsee [data-checkout]-napit kunnes ajankohta valittu.
   - Kun ajankohta on ok, nappi aukeaa → tämä gate ottaa vuoron ja
     vaatii puhelimen. Emme kilpaile samasta lukosta: sieppaamme itse
     klikin/submitin capture-vaiheessa ja päästämme läpi vasta kun
     numero on tallennettu.

   Ei riippuvuuksia. Event-delegaatio (capture) → kestää minicartin
   innerHTML-swapit.
   =================================================================== */
(function () {
  'use strict';

  var ATTR = 'Puhelin';
  var gate = document.querySelector('[data-phone-gate]');
  if (!gate) return;

  var input   = gate.querySelector('[data-phone-gate-input]');
  var errorEl = gate.querySelector('[data-phone-gate-error]');
  var submit  = gate.querySelector('[data-phone-gate-submit]');
  var overlay = gate.querySelector('[data-phone-gate-overlay]');
  var closeBtn= gate.querySelector('[data-phone-gate-close]');

  var pending = null;      // odottava kassatoiminto (jatketaan kun numero ok)
  var busy = false;
  var lastFocus = null;

  /* ---------- Numeron validointi ---------- */
  // Salli numerot, välit, +, -, (), sulut. Vaadi vähintään 7 numeroa.
  function normalize(v){ return String(v || '').trim(); }
  function isValid(v){
    var s = normalize(v);
    if (s === '') return false;
    if (!/^[+()\-\s0-9]+$/.test(s)) return false;
    var digits = s.replace(/\D/g, '');
    return digits.length >= 7 && digits.length <= 15;
  }

  /* ---------- Cart-attribuutin luku/kirjoitus ---------- */
  function getSavedPhone(){
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        return (cart && cart.attributes && cart.attributes[ATTR]) || '';
      })
      .catch(function(){ return ''; });
  }
  function savePhone(v){
    var attrs = {}; attrs[ATTR] = normalize(v);
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  /* ---------- Modaali ---------- */
  function openGate(){
    lastFocus = document.activeElement;
    gate.hidden = false;
    void gate.offsetWidth;               // reflow ennen transitionia
    gate.classList.add('is-open');
    gate.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    if (input) { input.focus(); input.select(); }
  }
  function closeGate(){
    gate.classList.remove('is-open');
    gate.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    pending = null;
    var onEnd = function(){
      gate.hidden = true;
      gate.removeEventListener('transitionend', onEnd);
    };
    gate.addEventListener('transitionend', onEnd);
    // fallback jos transition ei laukea
    setTimeout(function(){ if (!gate.classList.contains('is-open')) gate.hidden = true; }, 350);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch(e){} }
  }
  function showError(msg){
    if (!errorEl) return;
    if (msg) errorEl.textContent = msg;
    errorEl.hidden = false;
  }
  function clearError(){ if (errorEl) errorEl.hidden = true; }

  /* ---------- Kassatoiminnon jatkaminen ---------- */
  // Suoritetaan alkuperäinen kassatoiminto ILMAN gatea (merkitään ohitetuksi).
  function proceed(action){
    if (!action) return;
    if (action.type === 'submit') {
      var form = action.form, btn = action.button;
      // luo piilotettu submit-input jotta name="checkout" välittyy
      var marker = document.createElement('input');
      marker.type = 'hidden';
      marker.name = 'checkout';
      marker.value = '';
      form.appendChild(marker);
      form.__phoneGatePassed = true;
      if (form.requestSubmit) { form.requestSubmit(); }
      else { form.submit(); }
    } else if (action.type === 'link') {
      window.location.href = action.href;
    }
  }

  function confirmPhone(){
    if (busy) return;
    var v = input ? input.value : '';
    if (!isValid(v)) { showError('Tarkista puhelinnumero (vähintään 7 numeroa).'); if (input) input.focus(); return; }
    busy = true;
    if (submit) submit.disabled = true;
    var action = pending;
    savePhone(v)
      .then(function(){
        busy = false;
        if (submit) submit.disabled = false;
        gate.classList.remove('is-open');
        gate.setAttribute('aria-hidden','true');
        document.documentElement.style.overflow = '';
        gate.hidden = true;
        proceed(action);
      })
      .catch(function(){
        busy = false;
        if (submit) submit.disabled = false;
        showError('Tallennus epäonnistui. Yritä uudelleen.');
      });
  }

  /* ---------- Klikin/submitin sieppaus (capture) ---------- */

  // Minicart / korisivun linkki-checkout (<a data-checkout> tai a[href*="/checkout"])
  document.addEventListener('click', function(e){
    var el = e.target.closest && e.target.closest('a.cart-drawer__checkout, a.cart-page__checkout, [data-checkout]');
    if (!el || el.tagName !== 'A') return;
    // pickup lukitsee vielä → anna pickupin hoitaa (aria-disabled), älä avaa gatea
    if (el.getAttribute('aria-disabled') === 'true') return;
    if (gate.__passing) return;
    var href = el.getAttribute('href') || (window.Shopify ? '/checkout' : '/checkout');
    e.preventDefault();
    e.stopPropagation();
    getSavedPhone().then(function(saved){
      pending = { type: 'link', href: href };
      if (input) input.value = saved || '';   // esitäytä jos muistissa, muuten tyhjä
      clearError();
      openGate();
    });
  }, true); // capture: ennen pickupin bubble-handleria

  // Korisivun submit-napit (<button name="checkout">)
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('button[name="checkout"]');
    if (!btn) return;
    if (btn.disabled) return;                 // pickup-lukko hoitaa
    var form = btn.form || btn.closest('form');
    if (!form) return;
    if (form.__phoneGatePassed) return;       // jo ohitettu → anna mennä
    e.preventDefault();
    e.stopPropagation();
    getSavedPhone().then(function(saved){
      pending = { type: 'submit', form: form, button: btn };
      if (input) input.value = saved || '';   // esitäytä jos muistissa, muuten tyhjä
      clearError();
      openGate();
    });
  }, true);

  /* ---------- Modaalin kontrollit ---------- */
  if (submit) submit.addEventListener('click', confirmPhone);
  if (input) {
    input.addEventListener('input', clearError);
    input.addEventListener('keydown', function(e){ if (e.key === 'Enter'){ e.preventDefault(); confirmPhone(); } });
  }
  if (overlay) overlay.addEventListener('click', closeGate);
  if (closeBtn) closeBtn.addEventListener('click', closeGate);
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && gate.classList.contains('is-open')) closeGate();
  });
})();